<template>
  <section class="community-section" @touchstart="onTouchStart" @touchend="onTouchEnd">
    <!-- 왼쪽 패널 -->
    <div class="panel panel-left" :class="{ 'is-active': isActive }">
      <div class="img-wrap">
        <img src="@/assets/complex/bg_imgbox1.png" alt="" class="panel-bg" />
          <img
          v-for="(slide, index) in slides"
          :key="'left-' + index"
          :src="slide.left"
          alt=""
          class="panel-img"
          :class="{ 'is-visible': currentSlide === index }"
        />
        <span class="img-label">SPECIAL PLAN</span>
      </div>
      <div class="panel-text" :class="{ 'is-active': isActive }">
        <transition name="slide-up" mode="out-in">
          <div :key="currentSlide">
            <h3 class="panel-title">{{ slides[currentSlide].title }}</h3>
            <p class="panel-desc" v-html="slides[currentSlide].desc"></p>
            <p class="panel-subdesc" v-if="slides[currentSlide].subdesc" v-html="slides[currentSlide].subdesc"></p>
          </div>
        </transition>
      </div>
      <!-- 좌우 버튼 -->
      <div class="nav-btns" :class="{ 'is-active': isActive }">
        <button class="nav-btn" @click="prev">&larr;</button>
        <button class="nav-btn" @click="next">&rarr;</button>
      </div>
    </div>

    <!-- VIEW 버튼 (중앙) -->
    <div class="view-btn" :class="{ 'is-active': isActive }" @click="$router.push('/complex/plan')">
      <svg class="view-rotate-text" viewBox="0 0 160 160">
        <defs>
          <path id="communityCirclePath" d="M80,80 m-65,0 a65,65 0 1,1 130,0 a65,65 0 1,1 -130,0" />
        </defs>
        <text text-anchor="middle">
          <textPath href="#communityCirclePath" startOffset="25%">VIEW MORE</textPath>
        </text>
        <text text-anchor="middle">
          <textPath href="#communityCirclePath" startOffset="75%">VIEW MORE</textPath>
        </text>
      </svg>
      <span class="view-center">VIEW</span>
    </div>

    <!-- 오른쪽 패널 -->
    <div class="panel panel-right" :class="{ 'is-active': isActive }">
      <img
        v-for="(slide, index) in slides"
        :key="'right-' + index"
        :src="slide.right"
        alt=""
        class="right-img"
        :class="{ 'is-visible': currentSlide === index }"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'CommunitySection',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentSlide: 0,
      touchStartX: 0,
      touchEndX: 0,
      slides: [
        {
          left: require('@/assets/complex/slide_complex1_1.jpg'),
          right: require('@/assets/complex/slide_complex1_2_250711.jpg'),
          title: '수원을 대표할 랜드마크 디자인',
          desc: '커튼월룩 돌출형 입면 디자인,<br>스카이라운지 등 자부심 더하는 설계 적용'
        },
        {
          left: require('@/assets/complex/slide_complex2_1.jpg'),
          right: require('@/assets/complex/slide_complex2_2.jpg'),
          title: '삶을 확장하는 중대형 타입',
          desc: '74㎡ ~ 120타입까지, 라이프스타일을<br>고려한 다양한 중대형 타입 구성'
        },
        {
          left: require('@/assets/complex/slide_complex3_1.jpg'),
          right: require('@/assets/complex/slide_complex3_2.jpg'),
          title: '품격과 여유가 흐르는 단지 계획',
          desc: '법정 대비 최대 3배 규모의 커뮤니티,<br>세대당 2대 주차 가능, 남향 위주 단지 배치',
          subdesc: '본 단지의 커뮤니티 면적은 법정 기준 대비<br>각각 C3BL 약 2.8배, D3BL 약 3배 수준으로 계획되었습니다.'
        },
        {
          left: require('@/assets/complex/slide_complex4_1.jpg'),
          right: require('@/assets/complex/slide_complex4_2_250701.jpg'),
          title: '넉넉함이 남다른 공간 설계',
          desc: '4BAY 위주 계획, 돌출형 발코니(일부세대),<br>현관 창고, 드레스룸, 펜트리 등 수납 공간 최대화'
        }
      ]
    }
  },
  methods: {
    next() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length
    },
    prev() {
      this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length
    },
    onTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX
    },
    onTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].screenX
      const diff = this.touchStartX - this.touchEndX
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.next()
        } else {
          this.prev()
        }
      }
    },
    handleScroll(direction) {
      if (direction === 'down') {
        this.$emit('next-section')
      } else {
        this.$emit('prev-section')
      }
    }
  }
}
</script>

<style scoped>
.community-section {
  height: 100vh;
  background: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

/* 패널 공통 */
.panel {
  width: 50%;
  height: 100%;
  transition: transform 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.panel-left {
  background: #a6a195;
  position: relative;
  transform: translateX(-100%);
}

.panel-right {
  background: var(--thehue-primary);
  transform: translateX(100%);
  position: relative;
  overflow: hidden;
}

.right-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0;
  transition: opacity 0.8s ease;
}

.right-img.is-visible {
  opacity: 1;
}

.img-wrap {
  position: absolute;
  top: 12%;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
}

.panel-bg {
  width: 100%;
  height: auto;
  display: block;
}

/* 텍스트 인터랙티브 */
.panel-text {
  position: absolute;
  bottom: 24%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  width: 80%;
  opacity: 0;
  transition: opacity 0.7s ease 0.8s;
}

.panel-text.is-active {
  opacity: 1;
}

.panel-title {
  font-family: var(--font-family);
  font-size: 30px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 14px;
  letter-spacing: -0.5px;
}

.panel-desc {
  font-family: var(--font-family);
  font-size: 18px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.6;
}

.panel-subdesc {
  font-family: var(--font-family);
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1.5;
  margin-top: 10px;
  margin-bottom: -30px;
}

/* 좌우 버튼 */
.nav-btns {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 16px;
  opacity: 0;
  transition: opacity 0.6s ease 1.2s;
}

.nav-btns.is-active {
  opacity: 1;
}

.nav-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background: #fff;
  cursor: pointer;
  font-size: 20px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.nav-btn:hover {
  background: var(--sub-color);
  color: var(--thehue-primary);
}

.img-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: var(--font-family2);
  font-size: 48px;
  font-weight: 300;
  color: #fff;
  letter-spacing: 24px;
  text-align: center;
  white-space: nowrap;
  z-index: 5;
}

.panel-img {
  position: absolute;
  top: 52.5%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 81%;
  height: auto;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.8s ease;
}

.panel-img.is-visible {
  opacity: 1;
}

.panel-left.is-active {
  transform: translateX(0);
}

.panel-right.is-active {
  transform: translateX(0);
}

/* VIEW 버튼 (중앙) */
.view-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  z-index: 10;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: var(--thehue-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: visible;
  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.5s, background 0.3s ease;
}

.view-btn.is-active {
  transform: translate(-50%, -50%) scale(1);
}

.view-btn:hover {
  background: var(--sub-color);
}

.view-rotate-text {
  position: absolute;
  width: 155%;
  height: 155%;
  animation: rotate 10s linear infinite;
}

.view-rotate-text text {
  font-family: var(--font-family2);
  font-size: 11px;
  font-weight: 600;
  fill: var(--thehue-primary);
  letter-spacing: 2px;
}

.view-center {
  font-family: var(--font-family2);
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
  transition: color 0.3s ease;
}

.view-btn:hover .view-center {
  color: var(--thehue-primary);
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 트랜지션 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active {
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}

/* ===== Mobile Responsive ===== */
@media (max-width: 768px) {
  .community-section {
    height: auto;
    flex-direction: column;
    overflow: hidden;
  }

  .panel {
    width: 100%;
  }

  /* 왼쪽 패널: 세로 스택 */
  .panel-left {
    height: auto;
    padding: 48px 0 24px;
    transform: none;
    opacity: 1;
  }

  .panel-left.is-active {
    transform: none;
  }

  .img-wrap {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
  }

  .panel-bg {
    display: none;
  }

  .img-label {
    font-size: 20px;
    letter-spacing: 6px;
  }

  .panel-img {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    width: 100%;
    height: auto;
    display: none;
    border-radius: 12px;
  }

  .panel-img.is-visible {
    display: block;
    opacity: 1;
  }

  .panel-text {
    position: relative;
    bottom: auto;
    left: auto;
    transform: none;
    width: 100%;
    padding: 20px 24px 0;
    box-sizing: border-box;
  }

  .panel-text.is-active {
    opacity: 1;
  }

  .panel-title {
    font-size: 20px;
    margin-bottom: 8px;
  }

  .panel-desc {
    font-size: 14px;
  }

  .panel-subdesc {
    font-size: 11px;
    margin-top: 6px;
    margin-bottom: 0;
  }

  .nav-btns {
    position: relative;
    bottom: auto;
    left: auto;
    transform: none;
    justify-content: center;
    margin-top: 20px;
    gap: 12px;
  }

  .nav-btns.is-active {
    opacity: 1;
  }

  .nav-btn {
    width: 44px;
    height: 44px;
    font-size: 16px;
  }

  /* VIEW 버튼: 모바일에서 숨김 */
  .view-btn {
    display: none;
  }

  /* 오른쪽 패널 */
  .panel-right {
    height: 60vw;
    min-height: 200px;
    max-height: 360px;
    transform: none;
    opacity: 1;
  }

  .panel-right.is-active {
    transform: none;
  }
}
</style>
